import { DefaultHttpExceptionType, HttpException } from "http-repository-cache";
import DefaultExceptionTypes from "core/exceptions/DefaultExceptionTypes";
import Exception from "core/exceptions/Exception";

export default class MapperHttpExceptionToException {
  map<T, B>(httpException: HttpException<T, B>): Exception<B, T> {
    switch (httpException.type) {
      case DefaultHttpExceptionType.UNAUTHORIZED:
        return {
          type: DefaultExceptionTypes.UNAUTHORIZED,
          body: httpException.body,
        };
      case DefaultHttpExceptionType.FORBIDDEN:
        return {
          type: DefaultExceptionTypes.FORBIDDEN,
          body: httpException.body,
        };
      case DefaultHttpExceptionType.PAYMENT_REQUIRED:
        return {
          type: DefaultExceptionTypes.REQUIRE_SUBSCRIPTION,
          body: httpException.body,
        };
      case DefaultHttpExceptionType.NOT_FOUND:
        return {
          type: DefaultExceptionTypes.NOT_FOUND,
          body: httpException.body,
        };
      case DefaultHttpExceptionType.BAD_REQUEST:
        return {
          type: DefaultExceptionTypes.BAD_REQUEST,
          body: httpException.body,
        };
      case DefaultHttpExceptionType.CONFLICT:
        return {
          type: DefaultExceptionTypes.CONFLICT,
          body: httpException.body,
        };
      case DefaultHttpExceptionType.ABORT_REQUEST:
        return {
          type: DefaultExceptionTypes.ABORT_REQUEST,
          body: httpException.body,
        };
      case DefaultHttpExceptionType.SERVER_UNAVAILABLE:
        return {
          type: DefaultExceptionTypes.EXTERNAL_RESOURCE_UNAVAILABLE,
          body: httpException.body,
        };
      default:
        return {
          type: DefaultExceptionTypes.UNEXPECTED_ERROR,
          body: httpException.body,
        };
    }
  }
}
